// removed by extract-text-webpack-plugin
module.exports = {"panel":"_2_Ryh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabView/TabViewContent.scss
// module id = ./src/components/TabView/TabViewContent.scss
// module chunks = 5